import request from '@/utils/request'

const apis = {
  BE_TEACHER: '/school/beTeacher',
  GET_TEACHERINFO: 'teaching/getTeacherInfo',
  GET_USERMESSAGE: 'teaching/getUserMessage',
  GET_CLASSLIST: 'attendance/teamGroup/getTeamGroupListByUserId',
  GET_CLASSLISTS: 'attendance/teamGroup/getClassGroupListByUserId',
  GET_CLASSINFOLIST: 'attendance/teamGroup/getTeamGroupInfoListByUserId',
  GET_CLASSINFO: 'teaching/getClassInfo',
  GET_SIGNIN_OUTLINE: 'teaching/getGroupPeopleSigninOutLine',
  GET_SIGNIN_DETAILED: 'teaching/getGroupPeopleSigninDetailed',
  GET_SIGNIN_DATES: 'teaching/getGroupPeopleSigninDate',
  GET_EXERCISE_PROGRESS: 'teaching/getExerciseProgress',
  TEACHING_FACES_COMPARISON: 'teaching/teachingFacesComparison/teachingFacesComparison',
  GET_COMPARISON_RECORDLIST_TEAM: 'teaching/teachingFacesComparison/selectComparisonRecordList4Team',
  GET_GROUP_LIST_BY_TEACHER: 'attendance/getGroupListByTeacher',
  GET_STUDENT_DETAIL_LIST: 'attendance/getPracticalStudentDetailList',
  SUBMIT_RETURN_VISIT: 'graduation/returnVisit/submitReturnVisit',
  GET_RETURN_VISIT_BYSELF: 'graduation/returnVisit/getReturnVisitBySelf',
  GET_STUDENT_STUDY_INFO: 'graduation/returnVisit/getStudentStudyInfo',
  GET_SUPERVISIONRULES_BY_TEAMID: '/teaching/trainingSupervisionRules/getSupervisionRulesByTeamId',
  GET_TEACHER_SIGNINFO: '',
  GET_STATUS_MESSAGE:"/teaching/getStatusMessage"
}

export default {
  getStatusMessage(data) {
    let dt = data || {};
    return request.post(apis.GET_STATUS_MESSAGE, dt.params, {
      headers: dt.headers || {}
    });
  },
  // 信息列表
  beTeacher(data) {
    let dt = data || {};
    return request.post(apis.BE_TEACHER, dt.params, {
      headers: dt.headers || {}
    });
  },
  getUserMessage(data) {
    let dt = data || {};
    return request.post(apis.GET_USERMESSAGE, dt.params, {
      headers: dt.headers || {}
    });
  },
  getTeacherInfo(data) {
    let dt = data || {};
    return request.post(apis.GET_TEACHERINFO, dt.params, {
      headers: dt.headers || {}
    });
  },
  getClassInfo(data) {
    let dt = data || {};
    return request.post(apis.GET_CLASSINFO, dt.params, {
      headers: dt.headers || {}
    });
  },
  getClassList(data) {
    let dt = data || {};
    return request.post(apis.GET_CLASSLIST, dt.params, {
      headers: dt.headers || {}
    });
  },
  // 学员获取实训信息
  getClassLists(data) {
    let dt = data || {};
    return request.post(apis.GET_CLASSLISTS, dt.params, {
      headers: dt.headers || {}
    });
  },
  getClassInfoList(data) {
    let dt = data || {};
    return request.post(apis.GET_CLASSINFOLIST, dt.params, {
      headers: dt.headers || {}
    });
  },
  getGroupPeopleSigninOutLine(data) {
    let dt = data || {};
    return request.post(apis.GET_SIGNIN_OUTLINE, dt.params, {
      headers: dt.headers || {}
    });
  },
  getGroupPeopleSigninDetailed(data) {
    let dt = data || {};
    return request.post(apis.GET_SIGNIN_DETAILED, dt.params, {
      headers: dt.headers || {}
    });
  },
  getGroupPeopleSigninDate(data) {
    let dt = data || {};
    return request.post(apis.GET_SIGNIN_DATES, dt.params, {
      headers: dt.headers || {}
    });
  },
  getExerciseProgress(data) {
    let dt = data || {};
    return request.post(apis.GET_EXERCISE_PROGRESS, dt.params, {
      headers: dt.headers || {}
    });
  },
  teachingFacesComparison(data) {
    let dt = data || {};
    let params = dt.params || {};
    let formData = new FormData();
    for (let k in params) {
      if (k && params[k] != null) {
        formData.append(k + '', params[k]);
      }
    }
    console.log(formData)
    return request.post(apis.TEACHING_FACES_COMPARISON, formData, {
      headers: Object.assign({
        'Content-Type': 'multipart/form-data'
      }, dt.headers)
    });
  },
  selectComparisonRecordList4Team(data) {
    let dt = data || {};
    return request.post(apis.GET_COMPARISON_RECORDLIST_TEAM, dt.params, {
      headers: dt.headers || {}
    });
  },
  getGroupListByTeacher(data) {
    let dt = data || {};
    return request.post(apis.GET_GROUP_LIST_BY_TEACHER, dt.params, {
      headers: dt.headers || {}
    });
  },
  getStudentDetailList(data) {
    let dt = data || {};
    return request.post(apis.GET_STUDENT_DETAIL_LIST, dt.params, {
      headers: dt.headers || {}
    });
  },
  submitReturnVisit(data) {
    let dt = data || {};
    return request.post(apis.SUBMIT_RETURN_VISIT, dt.params, {
      headers: dt.headers || {}
    });
  },
  getReturnVisitBySelf(data) {
    let dt = data || {};
    return request.post(apis.GET_RETURN_VISIT_BYSELF, dt.params, {
      headers: dt.headers || {}
    });
  },
  getStudentStudyInfo(data) {
    let dt = data || {};
    return request.post(apis.GET_STUDENT_STUDY_INFO, dt.params, {
      headers: dt.headers || {}
    });
  },
  getSupervisionRulesByTeamId(data) {
    let dt = data || {};
    return request.post(apis.GET_SUPERVISIONRULES_BY_TEAMID, dt.params, {
      headers: dt.headers || {}
    });
  },

}


// WEBPACK FOOTER //
// ./src/api/school.js



// WEBPACK FOOTER //
// ./src/api/teacher.js